import ServiceCollection from "src/services/ServiceCollection";
import {Box} from "@amzn/awsui-components-react";
import React from "react";

export default function JEWorksheetTemplateView(props: { services: ServiceCollection }) {
    return (
        // TODO: Add JE worksheet template components
        <Box padding={{top: "xxl"}}>
        </Box>
    );
}
